// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sub-category form (redesign): 2-col layout + live preview, matching Category Studio. */

.SubCategoryStudioForm-layout-jdE9e {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 24px;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: start;
}

@media (max-width: 992px) {
  .SubCategoryStudioForm-layout-jdE9e {
    grid-template-columns: 1fr;
  }
}

.SubCategoryStudioForm-card-bmSF6 {
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 12px;
  border-radius: var(--radius-2, 12px);
  padding: 18px;
  background: #fff;
  background: var(--white-color, #fff);
}

.SubCategoryStudioForm-preview-pyiQx {
  position: sticky;
  top: 16px;
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 12px;
  border-radius: var(--radius-2, 12px);
  padding: 16px;
  background: #f9f9f9;
  background: var(--common-light-bg, #f9f9f9);
}

.SubCategoryStudioForm-previewTitle-piEel {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #909090;
  color: var(--content-text-secondary, #909090);
  margin-bottom: 12px;
}

.SubCategoryStudioForm-cardMock-VmHgY {
  background: #fff;
  background: var(--white-color, #fff);
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 12px;
  border-radius: var(--radius-2, 12px);
  padding: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 10px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.SubCategoryStudioForm-thumb-EzneQ {
  width: 44px;
  height: 44px;
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  -o-object-fit: cover;
     object-fit: cover;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.SubCategoryStudioForm-thumbPlaceholder-EPzvw {
  width: 44px;
  height: 44px;
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  -ms-flex-negative: 0;
      flex-shrink: 0;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  color: #fff;
  font-weight: 700;
  text-transform: uppercase;
  background: #d32f2f;
  background: var(--primary-bg, #d32f2f);
}

.SubCategoryStudioForm-name-Ihafg {
  font-weight: 700;
  color: #181817;
  color: var(--content-text, #181817);
}

.SubCategoryStudioForm-catBadge-z_cAw {
  font-size: 11px;
  color: #606060;
  color: var(--content-text-secondary, #606060);
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 999px;
  padding: 2px 10px;
  display: inline-block;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SiteAdmin/AddSubCategoryForm/SubCategoryStudioForm.css"],"names":[],"mappings":"AAAA,yFAAyF;;AAEzF;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,wBAAkB;MAAlB,qBAAkB;UAAlB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yBAA8C;EAA9C,8CAA8C;EAC9C,mBAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,gBAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,yBAA8C;EAA9C,8CAA8C;EAC9C,mBAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,mBAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAA6C;EAA7C,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,gBAAoC;EAApC,oCAAoC;EACpC,yBAA8C;EAA9C,8CAA8C;EAC9C,mBAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAmC;EAAnC,mCAAmC;EACnC,oBAAiB;KAAjB,iBAAiB;EACjB,oBAAc;MAAd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAmC;EAAnC,mCAAmC;EACnC,oBAAc;MAAd,cAAc;EACd,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,cAAmC;EAAnC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAA6C;EAA7C,6CAA6C;EAC7C,yBAA8C;EAA9C,8CAA8C;EAC9C,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":["/* Sub-category form (redesign): 2-col layout + live preview, matching Category Studio. */\n\n.layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 300px;\n  gap: 24px;\n  align-items: start;\n}\n\n@media (max-width: 992px) {\n  .layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.card {\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: var(--radius-2, 12px);\n  padding: 18px;\n  background: var(--white-color, #fff);\n}\n\n.preview {\n  position: sticky;\n  top: 16px;\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: var(--radius-2, 12px);\n  padding: 16px;\n  background: var(--common-light-bg, #f9f9f9);\n}\n\n.previewTitle {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--content-text-secondary, #909090);\n  margin-bottom: 12px;\n}\n\n.cardMock {\n  background: var(--white-color, #fff);\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: var(--radius-2, 12px);\n  padding: 12px;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.thumb {\n  width: 44px;\n  height: 44px;\n  border-radius: var(--radius-1, 6px);\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.thumbPlaceholder {\n  width: 44px;\n  height: 44px;\n  border-radius: var(--radius-1, 6px);\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 700;\n  text-transform: uppercase;\n  background: var(--primary-bg, #d32f2f);\n}\n\n.name {\n  font-weight: 700;\n  color: var(--content-text, #181817);\n}\n\n.catBadge {\n  font-size: 11px;\n  color: var(--content-text-secondary, #606060);\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: 999px;\n  padding: 2px 10px;\n  display: inline-block;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `SubCategoryStudioForm-layout-jdE9e`,
	"card": `SubCategoryStudioForm-card-bmSF6`,
	"preview": `SubCategoryStudioForm-preview-pyiQx`,
	"previewTitle": `SubCategoryStudioForm-previewTitle-piEel`,
	"cardMock": `SubCategoryStudioForm-cardMock-VmHgY`,
	"thumb": `SubCategoryStudioForm-thumb-EzneQ`,
	"thumbPlaceholder": `SubCategoryStudioForm-thumbPlaceholder-EPzvw`,
	"name": `SubCategoryStudioForm-name-Ihafg`,
	"catBadge": `SubCategoryStudioForm-catBadge-z_cAw`
};
module.exports = ___CSS_LOADER_EXPORT___;
